var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5685 3.66438C12.5825 3.02176 11.8712 1.99407 11.6505 0.797137C11.6014 0.537148 11.5769 0.272253 11.5769 0H8.43248L8.42758 12.6021C8.37362 14.0124 7.21348 15.1456 5.78844 15.1456C5.34695 15.1456 4.92999 15.0352 4.56208 14.8415C3.72079 14.3975 3.1444 13.517 3.1444 12.5016C3.1444 11.0446 4.32907 9.85752 5.78844 9.85752C6.06069 9.85752 6.32069 9.90167 6.56841 9.98015V7.51516V6.76953C6.31333 6.7352 6.05334 6.71312 5.78844 6.71312C2.59744 6.71312 0 9.31056 0 12.5016C0 14.4588 0.978641 16.1929 2.4699 17.2402C3.40929 17.9 4.55472 18.29 5.78599 18.29C8.97699 18.29 11.5744 15.6926 11.5744 12.5016V6.1122C12.8082 6.99763 14.319 7.52007 15.9501 7.52007V5.07714V4.37567C15.0745 4.37321 14.2553 4.11077 13.5685 3.66438Z",
    fill: "#F7FCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLight);
export default __webpack_public_path__ + "static/media/tiktokLight.14e1ba0fbfcc017b4ac8af5d140c4d29.svg";
export { ForwardRef as ReactComponent };